// src/components/VerifiedSellerBadge.js
import React from "react";
import verifiedTick from "../assets/verified_tick.png"; // Make sure this image exists

const VerifiedSellerBadge = ({ isVerified, size = 16 }) => {
  if (!isVerified) {
    return null;
  }

  return (
    <img
      src={verifiedTick}
      alt="Verified Seller"
      title="Verified Seller"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        marginLeft: "5px",
        verticalAlign: "middle", // Aligns the tick nicely with text
      }}
    />
  );
};

export default VerifiedSellerBadge;
